import { ReactElement, ReactNode } from 'react'

import {
  Dialog, DialogProps, DialogContent, 
	Box, Stack,
  FormGroup, FormGroupProps
} from '@mui/material'

import { Loading } from 'components/controls/loading'
import { ErrorBlock } from 'components/controls/errorInfo'

import { DialogAction } from './components/action'
import { DialogCaption } from './components/caption'

type FormDialogProps = {
  isLoading?: boolean
  percent?: number
  title: string
  note?: ReactElement
  body: ReactNode
  formGroupProps?: FormGroupProps
  error?: Error | Error[] | null
  encType?: string
  leftAction?: ReactElement
  isValid?: boolean
  submitLabel?: string
  onSubmit: (event: React.FormEvent<HTMLFormElement>) => void
  onBack?: () => void
  onClose: () => void
  disablePadding?: boolean
  children?: ReactNode
} & DialogProps

export const FormDialog = ({
  isLoading,
  percent,
  title,
  note,
  body,
  formGroupProps,
  error,
  encType,
  leftAction,
  isValid,
  submitLabel,
  onSubmit,
  onBack,
  onClose,
  disablePadding,
  children,
  ...others
}: FormDialogProps) => (
  <>
    <Dialog
      onClose={(_, reason) => {
        if (reason === 'backdropClick') return
        onClose()
      }}
      {...others}
      slotProps={{
        paper: {
          sx: {
            overflow: "hidden"
          }
        }
      }}
    >
      {isLoading && <Loading percent={percent}/>}

      <DialogCaption title={title} onBack={onBack} onClose={onClose}/>

      {note}

      <Box flexGrow={1} overflow="auto">
        <form onSubmit={onSubmit} encType={encType}>
          <Stack direction="column">
            <DialogContent
              style={{
                overflow: 'auto',
                padding: disablePadding === true ? 0 : undefined
              }}
            >
              <FormGroup {...formGroupProps}>
                <Stack direction="column" maxWidth="100%">
                  {body}
                </Stack>
              </FormGroup>
              <ErrorBlock error={error} marginTop={1}/>
            </DialogContent>
          </Stack>
          <DialogAction
            left={leftAction}
            isValid={isValid}
            submit={true}
            label={submitLabel}
            onCancel={onClose}
          />
        </form>
      </Box>

      {children}
    </Dialog>
  </>
)